import React, { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { LocateControl as LeafletLocateControl } from "leaflet.locatecontrol";
import "leaflet.locatecontrol/dist/L.Control.Locate.css";

const LocateControl = ({ options, startDirectly }) => {
    const map = useMap();
    const locateRef = useRef(null);

    useEffect(() => {
        console.log("LocateControl effect running, map exists:", !!map);
        // Only initialize if we have a map and don't already have a locate control
        if (!map || locateRef.current) return;
        
        try {
            // Initialize with safe defaults and user options
            const locateOptions = {
                position: 'topleft',
                showPopup: false,
                strings: {
                    title: 'Show me where I am'
                },
                locateOptions: {
                    enableHighAccuracy: true
                },
                icon: 'fa fa-location-arrow',
                iconLoading: 'fa fa-spinner fa-spin',
                keepCurrentZoomLevel: true,
                ...options
            };
            
            const lc = new LeafletLocateControl(locateOptions);
            
            // Safely add to map
            lc.addTo(map);
            console.log("Locate control initialized successfully");
            locateRef.current = lc;
            
            // Start if requested
            if (startDirectly) {
                try {
                    lc.start();
                } catch (error) {
                    console.error("Error starting locate control:", error);
                }
            }
        } catch (error) {
            console.error("Error initializing locate control:", error);
        }

        // Cleanup function - safely remove the control
        return () => {
            try {
                if (map && locateRef.current) {
                    // Try to stop the control first
                    if (typeof locateRef.current.stop === 'function') {
                        locateRef.current.stop();
                    }
                    
                    map.removeControl(locateRef.current);
                }
            } catch (error) {
                console.error("Error cleaning up locate control:", error);
            } finally {
                locateRef.current = null;
            }
        };
    }, [map, options, startDirectly]);

    return null;
};

export default LocateControl;